import $ from 'jquery';

export function beInit() {
	resizeTimelines();
	resizeVideo();
	
	$(window).resize(function() {
		resizeTimelines();
		resizeVideo();
	});
	
	$('#top').find('.btn-secondary').click(function() {
		$('html, body').animate({ scrollTop: ($('#timeline').offset().top - $('nav').height()) }, 500);
	});
	
	$('.tile').click(function() {
		$('.disc-details').find('.background').css('background-image', $(this).find('.background').css('background-image'));
		$('#disc_title').text($(this).find('h4').text());
		$('.disc-details').show();
		setTimeout(function() {
			$('.disc-details').removeClass('fade');
		}, 1);
		$('#disc_loader').show().removeClass('fade');
		
		var url_title = $(this).data('url_title');
		$.get('/ajax/discipline/' + url_title, function(response) {
			$('#disc_loader').addClass('fade');
			setTimeout(function() {
				$('#disc_loader').hide();
			}, 500);
			
			$('#disc_details').html(response).removeClass('fade');
			initVideo();
		});
	});
	
	$('.disc-details').on('click', '.close-button, h5', function() {
		$('.disc-details').addClass('fade');
		setTimeout(function() {
			$('.disc-details').hide();
			$('#disc_details').html('').addClass('fade');
			$('.video').find('iframe').attr('src', false);
		}, 500);
	});
	
	$('.staff-member').click(function() {
		var modal = $(this).find('.modal');
		if (modal.is(':visible')) {
			modal.addClass('fade');
			setTimeout(function() {
				modal.hide();
			}, 500);
		} else {
			modal.show();
			setTimeout(function() {
				modal.removeClass('fade');
			}, 1);
		}
	});
	
	$('.apply-now').attr('href', $('.steps-file').eq(0).attr('href'));
}
	
function resizeTimelines() {
	var i = 0;
	$('.black-line').each(function() {
		$(this).height($(this).closest('.milestone').outerHeight());
		if (i == 0) {
			$(this).css('margin-top','16px');		
		}
		i++;
	});
}

function initVideo() {
	var video = $('.video').find('iframe');
	video.attr('src', video.data('src'));
	resizeVideo();
}
function resizeVideo() {
	var video = $('.video').find('iframe');
	if (video.length > 0) {
		video.height(video.width() / 16 * 9);
	}
}